module.exports = __webpack_public_path__ + "static/media/6.dae106e7.JPG";